<template lang="html">
  <v-app>
    <v-toolbar
      app
      dark
      clipped-left
      color="primary"
      class="elevation-10">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <img src="/static/images/allura-elementia-logo-wt.png" height="80%"/>
      <v-spacer></v-spacer>
      <h3 v-if="totals.approved">Total Co-op Dollars: {{total_co_op}}</h3>
      <v-list-tile href="static/remodel_ppt__next_steps.pdf">
        <v-list-tile-avatar tile>
          <v-icon>fas fa-info-circle</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          Next Steps
        </v-list-tile-content>
      </v-list-tile>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-menu open-on-click bottom offset-y right min-width="200px">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" flat fab>
              <v-avatar
                size="36px"
                class="red">
                <img :src="$auth.user.picture" alt="alt">
              </v-avatar>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile to="/profile" >
              <v-list-tile-content>My Profile</v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile @click="$auth.logout()" class="">
              <v-list-tile-title align-end class="">Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      app
      v-model="drawer"
      fixed
      clipped>
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              Main Navigation
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list dense v-if="$auth.role && $auth.role === 'Remodeler'">
        <v-list-tile href="static/remodel_ppt__next_steps.pdf">
          <v-list-tile-avatar tile>
            <v-icon>fas fa-info-circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            Next Steps
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile to="/resources">
          <v-list-tile-avatar tile>
            <v-icon>fas fa-folders</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            Resources
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile to="/jobs">
          <v-list-tile-avatar tile>
            <v-icon>fas fa-hammer</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            Jobs
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile to="/profile">
          <v-list-tile-avatar tile>
            <v-icon>fas fa-user</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            My Profile
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile disabled>
          <v-list-tile-avatar tile>
            <v-icon disabled>fas fa-badge-dollar</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            My Leads (Coming Soon)
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            Territory Manager: {{profile.manager_email}}
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list dense v-if="$auth.role && ($auth.role === 'Territory Manager' || $auth.role === 'Super Admin')">
        <v-list-tile :to="{name: 'adminRemodelers'}">
          <v-list-tile-avatar tile>
            <v-icon>fas fa-user-hard-hat</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            Remodelers
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile :to="{name: 'adminJobs'}">
          <v-list-tile-avatar tile>
            <v-icon>fas fa-hammer</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            Jobs
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile to="/resources">
          <v-list-tile-avatar tile>
            <v-icon>fas fa-folders</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            Resources
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <slot />
    </v-content>
    <v-footer app>
      Allura Workbench
    </v-footer>
  </v-app>
</template>

<script>

export default{
  data () {
    return {
      totals: [],
      drawer: true,
      userId: '',
      profile: ''
    }
  },
  computed: {
    total_co_op () {
      return Number(this.totals.approved.co_op_amount).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    }
  },
  methods: {
    getBalance () {
      this.$http({
        method: 'get',
        url: '/remodeler/jobs-balance'
      }).then((response) => {
        this.totals = response.data
      })
    },
    getRemodeler () {
      this.$http({
        method: 'get',
        url: '/remodeler/profile'
      }).then((response) => {
        this.profile = response.data
        __insp.push(['identify', this.profile.email]);
      })
    }
  },
  created () {
    this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$auth.accessToken
  },
  mounted () {
    if (this.$auth.role === 'Remodeler') {
      this.getBalance()
      this.getRemodeler()
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/shared/Layout.vue